import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const slug = 'electrical-private-power-pole-installations';
const serviceId = 4
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Electrical Private Power Pole Installations",
        description: "Installing and maintaining private power poles for properties requiring dedicated electrical supply.",
        keywords: "private power pole installations Sydney, electrical power poles Sydney, licensed electricians Sydney, private power supply, power pole maintenance, safe power pole installation, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Electrical Private Power Pole Installations',
    description: 'Installing and maintaining private power poles for properties requiring dedicated electrical supply.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
